export default {
  setArchive: (state, payload) => {
    state.archive = [...state.archive, ...payload];
  },
  setMeta(state, payload) {
    state.meta = payload;
  },
  increasePage: (state) => {
    state.page++;
  },
  noResult: (state, payload) => {
    state.noResult = payload;
  },
  allArchivesLoaded: (state, payload) => {
    state.allArchivesLoaded = payload;
  },
  setWriting: (state, payload) => {
    state.writing = payload;
  },
  reset: (state) => {
    state.page = 1;
    state.archive = [];
    state.meta = null;
    state.allArchivesLoaded = false;
  },
};
